module.exports = __webpack_public_path__ + "img/friend4.d97b4cbc.png";